import React from 'react';
import { Form } from '../../../ui/universe';
import { Select, Tooltip } from 'tdesign-react';

/**
 * 多选 Select 参数渲染器
 */
function MulSelectRenderer({ params, value, showClose, onClose, onChange }) {
  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <div className="flex">
        <div style={{ maxWidth: '100%' }}>
          <Select
            options={params.options}
            keys={{
              value: 'value',
              label: 'text'
            }}
            placeholder="请选择"
            value={Array.isArray(value) ? value?.join('') : ''}
            onChange={(val) => {
              onChange && onChange(val ? [Number(val)] : []);
            }}
          />
        </div>
        {showClose && <i className="universe-icon univ-icon-close ml-10" onClick={onClose}></i>}
      </div>
    </Form.Item>
  );
}

export default MulSelectRenderer;
